import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/connectlessen-recipients`;

export const fetchRecipients = async () => (await axios.get(BASE)).data;

export const fetchCandidates = async (includeAll = false) => (
  await axios.get(`${BASE}/candidates`, { params: { include_all: includeAll } })
).data;

export const createManualRecipient = async (payload) => (await axios.post(BASE, payload)).data;

export const createUserRecipients = async (userIds, groupIds = []) => (
  await axios.post(`${BASE}/from-users`, { user_ids: userIds, group_ids: groupIds })
).data;

export const updateRecipient = async (id, payload) => (await axios.put(`${BASE}/${id}`, payload)).data;

export const bulkUpdateRecipients = async (ids, action, groupIds = []) => (
  await axios.post(`${BASE}/bulk`, { ids, action, group_ids: groupIds })
).data;

export const deleteRecipient = async (id) => (await axios.delete(`${BASE}/${id}`)).data;

export const fetchConnectGroups = async () => (
  await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/connectgroepen`)
).data;
